import {
  getEffectiveScope,
  getScopesForResource,
  hasPermission,
} from './permissionUtils'

import { useState } from 'react'

export function usePermissionDraft(permissions, permissionOptions, onChange) {
  const [pendingScopes, setPendingScopes] = useState({})
  const isEditMode = Boolean(onChange && permissionOptions)
  const perms = permissions ?? []

  const handleToggle = (resource, action) => {
    if (!isEditMode) return
    const granted = hasPermission(perms, resource, action)
    let updated
    if (granted) {
      updated = perms.filter(
        (p) => !(p.resource === resource && p.action === action),
      )
    } else {
      const scope = getEffectiveScope(
        getScopesForResource(perms, resource),
        pendingScopes,
        resource,
        permissionOptions,
        'all',
      )
      updated = [...perms, { resource, action, scope }]
      if (pendingScopes[resource] !== undefined) {
        setPendingScopes((prev) => {
          const { [resource]: _, ...rest } = prev
          return rest
        })
      }
    }
    onChange(updated)
  }

  const handleScopeChange = (resource, newScope) => {
    if (!isEditMode) return
    const hasExisting = perms.some((p) => p.resource === resource)
    if (!hasExisting) {
      setPendingScopes((prev) => ({ ...prev, [resource]: newScope }))
      return
    }
    const updated = perms.map((p) =>
      p.resource === resource ? { ...p, scope: newScope } : p,
    )
    onChange(updated)
  }

  return { perms, pendingScopes, isEditMode, handleToggle, handleScopeChange }
}
